import React, { useState } from "react";
import Link from "components/link";
import Collapsible from "components/collapsible";
import { useFilters } from "hooks/useStore";

const findNavItemByURL = (navigation, handle) => {
	for (const item of navigation) {
		const foundLink = item.links.find(link => link.url.includes(handle));
		if (foundLink) return item._key;
	}
	return null;
};

const CollectionNavigation = ({ navigation, handle }) => {
	const [activeKey, setActiveKey] = useState(findNavItemByURL(navigation, handle));
	const { toggleSlidePane } = useFilters(["toggleSlidePane"]);
	const setActiveAccordion = (key) => {
		setActiveKey(key === activeKey ? null : key);
	};

	return (
		<div className="w-full lg:w-10/12 lg:mt-5 collection-nav-v1">
			{navigation.map((nav) => (
				<Collapsible
					className="border-t py-5 gap-0"
					isOpen={activeKey === nav?._key}
					setIsOpen={() => setActiveAccordion(nav?._key)}
					title={<h4 className="font-bold text-left">{nav.title}</h4>}
					label={nav.title}
					key={nav?._key}>
					<div className="flex flex-col gap-3 pt-3 lg:pl-6">
						{nav?.links?.map((link) => (
							<Link
								tabIndex={activeKey === nav?._key ? 0 : -1}
								onClick={toggleSlidePane}
								state={{ preserveScroll: true }}
								activeClassName="font-bold border-b-2 border-beige"
								key={link?._key} to={link.url} className="mr-2 w-fit">
								{link.title}
							</Link>
						))}
					</div>
				</Collapsible>))}
		</div>
	);
};

export default CollectionNavigation;